(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amateurs"] && !Shopify.designMode) return;
  try {
    
    // gsap.registerPlugin(ScrollTrigger);

    //     gsap.to("#myVideo", {
    //         width: "100vw", // Fullscreen width
    //         height: "100vh", // Fullscreen height
    //         scrollTrigger: {
    //             trigger: "section",
    //             start: "top top",
    //             end: "bottom top",
    //             scrub: true,
    //             markers: false // Optional: remove this line to hide scroll markers
    //         }
    //     });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dealer-page"] && !Shopify.designMode) return;
  try {
    
    $('.tab-menu li a').on('click', function(){
		   	var target = $(this).attr('data-rel');
			$('.tab-menu li a').removeClass('active');
		   	$(this).addClass('active');
		   	$("#"+target).fadeIn('slow').siblings(".tab-box").hide();
		   	return false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["founders"] && !Shopify.designMode) return;
  try {
    
    gsap.registerPlugin(ScrollTrigger);

        gsap.to("#myVideo", {
            width: "100vw", // Fullscreen width
            height: "100vh", // Fullscreen height
            scrollTrigger: {
                trigger: "section",
                start: "top top",
                end: "bottom top",
                scrub: true,
                markers: false // Optional: remove this line to hide scroll markers
            }
        });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["past-ride"] && !Shopify.designMode) return;
  try {
    
  gsap.registerPlugin(ScrollTrigger);

  gsap.to("#myVideo", {
      width: "100vw",
      height: "100vh",
      scrollTrigger: {
          trigger: "section",
          start: "top top",
          end: "bottom top",
          scrub: true,
          markers: false
      }
  });

  //for popup & slider
  document.addEventListener("DOMContentLoaded", function () {
    const popUp = document.querySelector(".pop-up-overlay");
    const pastRidesContainer = document.querySelector(".past-rides-container");
    const pastRidesPosts = document.querySelectorAll(".ride-single-post");
    const closeBtn = document.querySelector(".close-btn");
    const $sliderContainer = $(".past-ride-slider-images");
  
    function showPopup() {
      popUp.style.display = "flex";
      setTimeout(() => {
        popUp.style.opacity = "1";
        popUp.querySelector(".past-ride-slider-container").style.transform = "scale(1)";
        popUp.querySelector(".past-ride-slider-container").style.opacity = "1";
      }, 10);
    }
  
    function hidePopup() {
      popUp.style.opacity = "0";
      popUp.querySelector(".past-ride-slider-container").style.transform = "scale(0.95)";
      popUp.querySelector(".past-ride-slider-container").style.opacity = "0";
      setTimeout(() => {
        popUp.style.display = "none";
      }, 300);
    }
  
    popUp.addEventListener("click", function (e) {
      if (
        e.target === this ||
        e.target.closest(".close-btn") || 
        e.target.closest(".close-btn-container") ||
        (e.target.classList.contains("past-ride-slider-header") && e.target.tagName === "DIV") ||
        (e.target.classList.contains("slider-container") && e.target.tagName === "DIV") ||
        (e.target.classList.contains("past-ride-slider-container") && e.target.tagName === "DIV") ||
        (e.target.classList.contains("nav-btns") && e.target.tagName === "DIV")
      ) {
        hidePopup();
      }
    });
  
    //press esc to close popup
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && popUp.style.display === "flex") {
        hidePopup();
      }
    });

    // Initialize slider
    function initSlider() {
      $sliderContainer.slick({
        centerMode: true,
        centerPadding: "0vw",
        slidesToShow: 1,
        infinite: true,
        arrows: false,
        variableWidth: true,
      });
    }

    //Destroy the slider
    function destroySlider() {
      if ($sliderContainer.hasClass('slick-initialized')) {
        $sliderContainer.slick('unslick');
      }
    }
  
    // show popup & Set up slider content for each ride
    pastRidesPosts.forEach((post) => {
      post.addEventListener("click", function () {
        const rideTitle = post.getAttribute("data-ride-title");
        const images = [];
        let i = 1;
        while (post.getAttribute(`data-ride-img-${i}`)) {
          images.push(post.getAttribute(`data-ride-img-${i}`));
          i++;
        }

        showPopup();
    
        const rideSliderTitle = document.getElementById("popup-slider-title");
        rideSliderTitle.textContent = rideTitle;
    
        destroySlider();
        $sliderContainer.empty();
    
        images.forEach((imgSrc) => {
          $sliderContainer.append(`<div><img src="${imgSrc}" alt="" /></div>`);
        });
    
        initSlider();
      });
    });
  
    //nav btns
    $(".btn-prev").click(function () {
      $sliderContainer.slick("slickPrev");
    });
    
    $(".btn-next").click(function () {
      $sliderContainer.slick("slickNext");
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-zoom"] && !Shopify.designMode) return;
  try {
    

function initGSAPAnimation() {

  gsap.registerPlugin(ScrollTrigger);

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: "video#aboutVideo",
      scrub: true,
      // pin: true,
      start: "30% 50%",
      end: "bottom bottom"
    }
  });

  tl.from("video#aboutVideo", {
    // scale: 0.3,
    // xPercent: -12,
    // yPercent: -35,
    ease: "none"
  });
}

// Function to check viewport width and conditionally initialize GSAP animation
function checkViewportAndInit() {
  if (window.innerWidth > 768) {
    initGSAPAnimation();
  } else {
    // Optional: Clean up or destroy ScrollTrigger animations if necessary
    ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  }
}

// Run on initial load
checkViewportAndInit();

  } catch(e) { console.error(e); }
})();
})();
